export default "__VITE_ASSET__BZs0tIgU__"